import { useContext, useState, useRef, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  useMediaQuery,
  Container,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import lightLogo from "../../../Images/fouchain-logo-light.svg";
import darkLogo from "../../../Images/fouchain-logo-dark.svg";
import { ThemeContext } from "../../DarkMode/ThemeProvider";
import "../Outerpage.css";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";

import socket from "../../../utils/Socket";

const menuItems = [
  { label: "Home", path: "/" },
  { label: "About us", sectionId: "about-us-id" },
  { label: "Why Choose us", sectionId: "feature-id" },
  { label: "How its work", sectionId: "how-it-works-id" },
  { label: "Security", sectionId: "security-id" },
  { label: "FAQ", sectionId: "faq-id" },
];



const OuterPageHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const { isLightMode } = useContext(ThemeContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("Home");

  const handleScrollToSection = (id, label) => {
    setActiveItem(label);

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    if (location.pathname === "/") {
      setActiveItem("Home");
    }
  }, [location.pathname]);



  function maskEmail(email) {
    const [name, domain] = email.split('@');
    const maskedName = name.slice(0, 2) + '***';
    return maskedName + '@' + domain;
  }

  //custom code
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { userDetailData, userDetailStatus } = useSelector((state) => state.user);
  const { stpLoading, stpData, stpError, stpStatus, selectedPair } = useSelector((state) => state.tradeSTP);

  const [maskedEmail, setMaskedEmail] = useState("")

  const hasFetchedOnce = useRef(false);

  const dispatch = useDispatch();
  const [userDetail, setUserDetail] = useState({});
  const { settings } = useSelector((state) => state.site);
  const [selectedSymbol, setSelectedSymbol] = useState('BTCUSDT');


  useEffect(() => {
    if (userDetailStatus === true) {
      setMaskedEmail(maskEmail(userDetailData?.email))
    }


    if (location?.pathname) {

      const queryParams = new URLSearchParams(location.search);
      queryParams.delete("symbol");
    }

  }, [location])

  useEffect(() => {
    if (location.pathname === "/trade" && stpStatus === true) {
      if (stpData?.result?.length > 0) {
        const defaultSymbol = stpData?.result[0]?.symbol;
        setSelectedSymbol(defaultSymbol);

        const queryParams = new URLSearchParams(location.search);
        if (!queryParams.get("symbol")) {
          queryParams.set("symbol", defaultSymbol);
          navigate(`${location.pathname}?${queryParams.toString()}`);
        }
      }
    }
  }, [location.pathname, stpStatus, stpData]);

  // notification socket 
  const notifRefs = useRef({});
  const { notifications } = useSelector((state) => state.notification);
  const [notificationList, setNotificationList] = useState([]);

  useEffect(() => {
    // no-op if the socket is already connected
    socket.connect();
    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socket.on("updatenotification", (data) => {
      setNotificationList((prevData) =>
        prevData.map((item) => {
          if (item.uid === data.uid) {
            return {
              ...item,
              title: data.title,
              description: data?.description,
              deleteStatus: data?.deleteStatus,
              createdAt: data?.createdAt,
              status: data?.status,
            };
          }
          return item;
        })
      );
    });
    return () => {
      socket.off("updatenotification");
    };
  }, [notifications]);

  useEffect(() => {
    if (notifications && notifications.length > 0) {
      setNotificationList((prevList) => {
        const merged = [...prevList, ...notifications];
        const uniqueMap = new Map();
        merged.forEach((n) => uniqueMap.set(n._id, n)); // Assuming _id is unique
        return Array.from(uniqueMap.values());
      });
    }
  }, [notifications]);

  return (
    <AppBar position="fixed" elevation={0} sx={{ background: "transparent", py: 2, zIndex: 9 }}>
      <Container maxWidth="xl">
        <Toolbar
          sx={{
            background: "rgb(32 34 36)",
            borderRadius: "50px",
            px: { xs: 2, md: 3 },
            boxShadow: " 0 1.229px 4.915px 0 rgba(38, 40, 46, 0.37)",
            display: "flex",
            justifyContent: "space-between",
            border: '1.229px solid #37393C',
            zIndex: '999'
          }}
        >
          {/* LOGO */}
          <Link to="/">
            <Box display="flex" alignItems="center">
              <img
                src={isLightMode ? darkLogo : lightLogo}
                alt="logo"
                width={120}
              />
            </Box>
          </Link>

          {!isMobile && (
            <Box display="flex" sx={{ gap: { md: 2.5, lg: 5 } }}>
              {menuItems.map((item) =>
                item.sectionId ? (
                  <Box
                    key={item.label}
                    onClick={() => {
                      setActiveItem(item.label);
                      handleScrollToSection(item.sectionId, item.label);
                    }} className={`${activeItem === item.label ? "gold-color" : ""}`}
                    sx={{
                      cursor: "pointer",
                      fontSize: { md: 16, lg: 17 },
                      fontWeight: 400,
                      position: "relative",
                      color: activeItem === item.label ? "#F8BC36" : "#FFFFFF",
                      "&:hover": { color: "#F8BC36" },
                    }}
                  >
                    {item.label}
                  </Box>
                ) : (
                  <NavLink className={`${activeItem === item.label ? "gold-color" : ""}`}
                    key={item.label}
                    to={item.path}
                    onClick={() => setActiveItem(item.label)}
                    style={({ isActive }) => ({
                      textDecoration: "none",
                      fontSize: { md: 16, lg: 17 },
                      fontWeight: 400,
                      color:
                        isActive || activeItem === item.label
                          ? "#F8BC36"
                          : "#FFFFFF",
                    })}
                  >
                    {item.label}
                  </NavLink>
                )
              )}
            </Box>
          )}

          {!isMobile ? (
            <Box display="flex" alignItems="center" gap={3}>
              {!isAuthenticated ?
                <>
                  <NavLink
                    to="/login"
                    className='gold-color'
                    style={{
                      textDecoration: "none",
                      fontSize: 18,
                      color: "#111827",
                      fontWeight: 600,
                    }}
                  >
                    Login
                  </NavLink>
                  <div className="golden-btn">

                    <Button
                      onClick={() => navigate("/register")}
                    >
                      Sign Up
                    </Button>
                  </div>
                </>
                :
                <div className="golden-btn">
                  <Button onClick={() => navigate("/portfolio")} >Portfolio</Button>
                </div>
              }
            </Box>
          ) : (
            <IconButton onClick={() => setOpen(true)}>
              <MenuIcon sx={{ color: '#fff' }} />
            </IconButton>
          )}
        </Toolbar>
      </Container>

      {/* MOBILE DRAWER */}
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)} PaperProps={{
        sx: {
          background: "linear-gradient(90deg, #0D0D0C 0%, #0D0D0C 100%)",
          color: "#fff",
        },
      }}>
        <Box sx={{ display: "flex", justifyContent: 'space-between', p: 1 }}>
          <Link to={'/'}>
            <div className="logo">
              <img width={120} src={!isLightMode ? lightLogo : darkLogo} alt="logo" />
            </div>
          </Link>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon sx={{ color: "#fff", fontSize: 28 }} />
          </IconButton>
        </Box>
        <Box sx={{ width: 260, padding: '0px 16px' }}>
          <List>
            {menuItems.map((item) => (
              <ListItem key={item.label} disablePadding>
                <ListItemButton
                  onClick={() => {
                    setOpen(false);
                    setActiveItem(item.label);

                    if (item.sectionId) {
                      handleScrollToSection(item.sectionId, item.label);
                    } else {
                      navigate(item.path);
                    }
                  }}
                  sx={{
                    borderRadius: 2, mb: 1, "&.active": {
                      color:
                        activeItem === item.label
                          ? "#F8BC36 !important"
                          : "var(--color-PrimaryText)",
                      fontWeight: activeItem === item.label ? 600 : 400,
                    },
                  }}
                  className={`${activeItem === item.label ? "gold-color" : ""}`}
                >
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>

          <Box display="flex" justifyContent="center" gap={3}>
            {
              !isAuthenticated ? <>
                <NavLink
                  to="/login"
                  className='gold-color'
                  style={{
                    textDecoration: "none",
                    fontSize: 16,
                    color: "#111827",
                    fontWeight: 600,
                  }}
                >
                  Login
                </NavLink>
                <div className="golden-btn">

                  <Button
                    onClick={() => navigate("/register")}
                  >
                    Sign Up
                  </Button>
                </div>
              </>
                :
                <div className="golden-btn">
                  <Button
                    onClick={() => navigate("/portfolio")}
                  >
                    Dashboard
                  </Button>
                </div>
            }
          </Box>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default OuterPageHeader;
